<div class="menu-item">

  <div class="menu-header w-100 d-flex justify-content-between">
    <div>
      {{ item.title }}
      <button class="btn" *ngIf="item.children?.length" (click)="showChildren = !showChildren">
        <i class="fi fi-rr-add d-flex align-items-center" *ngIf="!showChildren"></i>
        <i class="fi fi-rr-minus-circle d-flex align-items-center" *ngIf="showChildren"></i>
      </button>
    </div>

    <div>
      <button class="btn btn-sm btn-primary" (click)="openEditModal()">
        <i class="fi fi-rr-edit"></i>
      </button>
    </div>
  </div>

  <!-- CHILDREN -->
  <div
    class="children"
    *ngIf="showChildren"
    cdkDropList
    [cdkDropListData]="item.children"
    (cdkDropListDropped)="dropChild($event)"
  >
    <div
      class="menu-drag-container child-drag"
      *ngFor="let child of item.children"
      cdkDrag
    >
      <div cdkDragHandle class="drag-handle"><i class="fi fi-rr-arrows"></i></div>

      <!-- Recursive app-menu-item -->
      <app-menu-item
        [item]="child"
        [allMenu]="allMenu"
        (update)="update.emit()"
        (dragChanged)="dragChanged.emit($event)"
      ></app-menu-item>

      <ng-template cdkDragPlaceholder>
        <div class="menu-drag-container drag-placeholder"></div>
      </ng-template>
    </div>
  </div>

</div>